import { render, staticRenderFns } from "./MsalespeopleIndex.vue?vue&type=template&id=0a37f1a8&scoped=true"
import script from "./MsalespeopleIndex.vue?vue&type=script&lang=js"
export * from "./MsalespeopleIndex.vue?vue&type=script&lang=js"
import style0 from "./MsalespeopleIndex.vue?vue&type=style&index=0&id=0a37f1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a37f1a8",
  null
  
)

export default component.exports